module.exports = __webpack_public_path__ + "components/promo-app/static/app-desktop-bg-0df3d8c68e4ba1479fe3e1625fef05a0.jpg";